"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionLogsDialog = void 0;
const react_1 = __importStar(require("react"));
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const components_1 = require("@veeam/components");
const components_2 = require("../../../components");
const constants_1 = require("../../../constants");
const core_1 = require("../../../core");
require("../../../core/request/types");
const helpers_1 = require("./helpers");
require("./types");
const INITIAL_SORT = {
    orderColumn: 'creationTimeUtc',
    orderAsc: false,
};
const LOGS_HEIGHT = 256;
const PAGINATION_HEIGHT = 48;
const SessionLogsDialog = ({ deactivate, activeProps, sessionsTypeRenderer = helpers_1.defaultSessionsTypeRenderer, withPaging = false, }) => {
    var _a, _b, _c, _d, _e;
    const { t, getProxy } = core_1.useFeatureContext();
    const { getConfig } = core_1.useAppContext();
    const { pageLimit } = getConfig();
    const groupId = (_a = activeProps === null || activeProps === void 0 ? void 0 : activeProps.rowData) === null || _a === void 0 ? void 0 : _a.groupId;
    const sessionId = (_b = activeProps === null || activeProps === void 0 ? void 0 : activeProps.rowData) === null || _b === void 0 ? void 0 : _b.sessionId;
    const isGroupDialog = !!(groupId && groupId !== constants_1.GUID_EMPTY);
    const [loading, setLoading] = react_1.useState(false);
    const [pagination, setPagination] = react_1.useState({ total: 0, page: 1 });
    const [selectedRows, setSelectedRows] = react_1.useState([]);
    const [sort, setSort] = react_1.useState(INITIAL_SORT);
    const handleSort = (field) => {
        setSort((state) => ({
            orderColumn: field,
            orderAsc: field !== state.orderColumn ? true : !state.orderAsc,
        }));
    };
    const getSessionProxyRef = react_1.useRef(isGroupDialog ? getProxy('getSessionsByGroup') : getProxy('getSession'));
    const [sessionsResult, sessionsActions] = core_1.useRequest({
        httpProxy: getSessionProxyRef.current,
        params: isGroupDialog ? { groupId } : { sessionId },
        mapper: (resp) => {
            if (isGroupDialog) {
                return resp.data;
            }
            return [resp];
        },
    });
    const sessionsGridData = sessionsResult.data || [];
    const firstLoaded = react_1.useRef(false);
    const doRequest = (sortProps, paginationProps) => {
        if (!firstLoaded.current) {
            setLoading(true);
        }
        const filterQuery = { sort: sortProps };
        if (withPaging) {
            filterQuery.skip = pageLimit * (paginationProps.page - 1);
            filterQuery.count = pageLimit;
        }
        return rxjs_1.from(sessionsActions.load({ filterQuery }).then(({ data }) => {
            if (data && !firstLoaded.current) {
                setLoading(false);
                const firstRec = data[0];
                setSelectedRows([firstRec]);
                if (withPaging) {
                    const total = helpers_1.getTotal(firstRec);
                    setPagination((state) => (Object.assign(Object.assign({}, state), { total })));
                }
                firstLoaded.current = true;
            }
        }));
    };
    react_1.useEffect(() => {
        firstLoaded.current = false;
        const pollingSubscription = rxjs_1.of({})
            .pipe(operators_1.mergeMap(() => doRequest(sort, pagination)), operators_1.delay(constants_1.DELAYS.polling), operators_1.repeat())
            .subscribe();
        return () => pollingSubscription.unsubscribe();
    }, [sort, pagination.page]);
    react_1.useEffect(() => {
        if (sessionsGridData.length && selectedRows.length) {
            const rec = selectedRows[0];
            const newRec = sessionsGridData.filter((item) => item.id === rec.id)[0];
            if (newRec) {
                setSelectedRows([newRec]);
                if (withPaging) {
                    const total = helpers_1.getTotal(newRec);
                    setPagination((state) => (Object.assign(Object.assign({}, state), { total })));
                }
            }
        }
    }, [sessionsGridData]);
    const updatePage = (page) => {
        setPagination((state) => (Object.assign(Object.assign({}, state), { page })));
    };
    return (react_1.default.createElement(components_1.Dialog, { header: `${sessionsTypeRenderer(((_c = activeProps === null || activeProps === void 0 ? void 0 : activeProps.rowData) === null || _c === void 0 ? void 0 : _c.sessionType) || '')}${((_d = activeProps === null || activeProps === void 0 ? void 0 : activeProps.rowData) === null || _d === void 0 ? void 0 : _d.name) ? `: ${(_e = activeProps === null || activeProps === void 0 ? void 0 : activeProps.rowData) === null || _e === void 0 ? void 0 : _e.name}` : ''}`, size: {
            width: components_1.DIALOG_SIZE.xxl,
            height: components_1.DIALOG_SIZE.xxl,
        }, onRequestClose: () => {
            deactivate();
        }, actions: [
            {
                view: components_1.ACTION_VIEW.primary,
                text: t('sessionsLogDialog|actions|close'),
                onClick: () => deactivate(),
            },
        ] },
        react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.column, distribution: components_1.STACK_DISTRIBUTION.lastFill, gap: components_1.STACK_GAP.m },
            react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.column, distribution: components_1.STACK_DISTRIBUTION.lastFill, size: { height: '40%' } },
                react_1.default.createElement(components_1.Text, { size: components_1.TEXT_SIZE.l, weight: components_1.TEXT_WEIGHT.bold }, t('sessionsLogDialog|subHeader|status')),
                react_1.default.createElement(components_2.Grid, { id: "groupSessionsGrid", idKey: "id", loading: loading, resizable: true, selected: selectedRows.map(({ id }) => id), sort: sort || INITIAL_SORT, sorting: handleSort, data: sessionsGridData, columns: helpers_1.getColumnsSessions(t), onSelect: (selectedItems) => setSelectedRows(selectedItems) })),
            react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.column, distribution: components_1.STACK_DISTRIBUTION.lastFill },
                react_1.default.createElement(components_1.Text, { size: components_1.TEXT_SIZE.l, weight: components_1.TEXT_WEIGHT.bold }, t('sessionsLogDialog|subHeader|log')),
                react_1.default.createElement(components_2.Table, { data: loading ? [] : helpers_1.getLogs(selectedRows[0]), bodyHeight: `${LOGS_HEIGHT - (pagination.total > pageLimit ? PAGINATION_HEIGHT : 0)}px`, columns: helpers_1.getColumnsLogs(t), hasSelection: true }),
                pagination.total > pageLimit && (react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row, distribution: components_1.STACK_DISTRIBUTION.center },
                    react_1.default.createElement(components_1.Pagination, { disabled: loading, lastPage: Math.ceil(pagination.total / pageLimit), activePage: pagination.page, onPageChange: (page) => updatePage(page), onPageClick: (page) => updatePage(page) })))))));
};
exports.SessionLogsDialog = SessionLogsDialog;
exports.SessionLogsDialog.displayName = 'SessionLogsDialog';
//# sourceMappingURL=SessionLogsDialog.js.map